import styled from "styled-components";
import { Icon } from "../../Icon";
import { iconTextSpacing } from "../config";
export const IconWithinText = styled(Icon) `
  &.left {
    margin-right: ${iconTextSpacing};
  }

  &.right {
    margin-left: ${iconTextSpacing};
  }
`;
export default IconWithinText;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiSWNvbldpdGhpblRleHQuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi8uLi9zcmMvY29tcG9uZW50cy9UZXh0V2l0aEljb25MYXlvdXQvc3R5bGVkL0ljb25XaXRoaW5UZXh0LnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBLE9BQU8sTUFBTSxNQUFNLG1CQUFtQixDQUFDO0FBQ3ZDLE9BQU8sRUFBRSxJQUFJLEVBQUUsTUFBTSxZQUFZLENBQUM7QUFDbEMsT0FBTyxFQUFFLGVBQWUsRUFBRSxNQUFNLFdBQVcsQ0FBQztBQUU1QyxNQUFNLENBQUMsTUFBTSxjQUFjLEdBQUcsTUFBTSxDQUFDLElBQUksQ0FBQyxDQUFBOztvQkFFdEIsZUFBZTs7OzttQkFJaEIsZUFBZTs7Q0FFakMsQ0FBQztBQUVGLGVBQWUsY0FBYyxDQUFDIn0=